import React from "react";

interface Props {
  size?: number;
}

const ArrowLeftIcon = ({ size = 16 }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 17 18"
    >
      <path stroke="currentColor" d="M17 9H1.533M8.467 1L1 9l7.467 8"></path>
    </svg>
  );
};

export default ArrowLeftIcon;
